import type { ChangeWorkGroupMember } from '../../types/changes';

/** Opções de gerente imediato: todos do grupo; gestor pode escolher a si mesmo. */
export function immediateManagerChoicesForMember(
  allMembers: ChangeWorkGroupMember[],
  member: ChangeWorkGroupMember,
): ChangeWorkGroupMember[] {
  return allMembers.filter((entry) => {
    if (entry.user_id === member.user_id) {
      return Boolean(member.is_manager);
    }
    return true;
  });
}
